import React from 'react'
import { WorkspaceWrapperUseStyles } from './style'
import { WorkspaceWrapperView } from './view'
import { IWorkspaceWrapper } from './interfaces'

export const WorkspaceWrapper: React.FC<IWorkspaceWrapper> = ({ ...props }) => {
  const classes = WorkspaceWrapperUseStyles()
  return <WorkspaceWrapperView classes={classes} {...props} />
}
